module.exports = __webpack_public_path__ + "img/YBC.afd2a85e.svg";